import { BodyResearchTypePractice } from 'practice/view-models/research-type-practice';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCells: HeadCell<BodyResearchTypePractice, keyof BodyResearchTypePractice>[] = [
  {
    id: 'code',
    label: 'Codice',
  },
  {
    id: 'descriptionBrief',
    label: 'Descrizione breve',
  },
  {
    id: 'description',
    label: 'Descrizione',
  },
  {
    id: 'register',
    label: 'Registro',
  },
  {
    id: 'initiative',
    label: 'Iniziativa',
  },
  {
    id: 'measure',
    label: 'Unità misura tempo',
  },
  {
    id: 'timeStandard',
    label: 'Tempo standard',
  },
  {
    id: 'timeMax',
    label: 'Tempo max',
  },
  {
    id: 'action',
    label: '',
  },
];
